import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import InviteTokens from '../../Components/InviteTokens/InviteTokens';
import { actions } from '../SocialMedia/slice';
import { teamSelector } from '../SocialMedia/selectors';
import InviteTokenAPI from '../../Lib/Api/invite-token';

const mapStateToProps = (state) => ({
  team: teamSelector(state),
});
const mapDispatchToProps = (dispatch) => ({
  getTeam: () => dispatch(actions.getTeam()),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )((props) => (
    <InviteTokens
      {...props}
      getTokens={InviteTokenAPI.getAll}
      refresh={InviteTokenAPI.refresh}
    />
  )),
);
